import { create } from 'zustand';

interface ILandingPageStore {
    openSecurity: boolean;
    openUserManagement: boolean;
    selectedItem: string | null;
    isCollapsed: boolean;
    openModal: boolean;
    setOpenModal: (openModal: boolean) => void;
    setOpenSecurity: (openSecurity: boolean) => void;
    setOpenUserManagement: (openSecurity: boolean) => void;
    setSelectedItem: (selectedItem: string | null) => void;
    setIsCollapsed: (isCollapsed: boolean) => void;
}

const useLandingPageStore = create<ILandingPageStore>((set) => ({
    openSecurity: false,
    openUserManagement: false,
    selectedItem: null,
    isCollapsed: false,
    openModal: true,
    setOpenModal: (openModal) => set({ openModal }),
    setOpenSecurity: (openSecurity) => set({ openSecurity }),
    setOpenUserManagement: (openUserManagement) => set({ openUserManagement }),
    setSelectedItem: (selectedItem) => set({ selectedItem }),
    setIsCollapsed: (isCollapsed) => set({ isCollapsed }),
}));

export default useLandingPageStore;